import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import './App.css'
import HomePage from './pages/HomePage'
import TestPage from './pages/TestPage'
import ApiDemoPage from './pages/ApiDemoPage'
import Layout from './layouts/Layout'

const App: React.FC = () => {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/test" element={<TestPage />} />
          <Route path="/api-demo" element={<ApiDemoPage />} />
        </Routes>
      </Layout>
    </Router>
  )
}

export default App